import { createSelector } from 'reselect';

import { sortPeriods } from '../../utils/sortPeriods';
import { civilSectionAcademicYearsDataSelector } from './civil/civilSectionAcademicYearsDataSelector';
import { creationSectionAcademicYearsDataSelector } from './creation/creationSectionAcademicYearsDataSelector';
import { cultureSectionAcademicYearsDataSelector } from './culture/cultureSectionAcademicYearsDataSelector';
import { professionSectionAcademicYearsDataSelector } from './profession/professionSectionAcademicYearsDataSelector';
import { scienceSectionAcademicYearsDataSelector } from './science/scienceSectionAcademicYearsDataSelector';
import { sportSectionAcademicYearsDataSelector } from './sport/sportSectionAcademicYearsDataSelector';
import { studySectionAcademicYearsDataSelector } from './study/studySectionAcademicYearsDataSelector';

export const academicYearsSelector = createSelector(
  [
    // Данные раздела учёба
    studySectionAcademicYearsDataSelector,
    // Данные раздела наука
    scienceSectionAcademicYearsDataSelector,
    // Данные раздела спорт
    sportSectionAcademicYearsDataSelector,
    // Данные раздела творчество
    creationSectionAcademicYearsDataSelector,
    // Данные раздела культура
    cultureSectionAcademicYearsDataSelector,
    // Данные раздела гражданская активность
    civilSectionAcademicYearsDataSelector,
    // Данные раздела моя профессия
    professionSectionAcademicYearsDataSelector,
  ],
  (
    // Учеба
    studySectionAcademicYearsData,
    // Наука
    scienceSectionAcademicYearsData,
    // Спорт
    sportSectionAcademicYearsData,
    // Творчество
    creationSectionAcademicYearsData,
    // Культура
    cultureSectionAcademicYearsData,
    // Гражданская активность
    civilSectionAcademicYearsData,
    // Моя профессия
    professionSectionAcademicYearsData,
  ) => {
    const periods: Set<string> = new Set([
      // Учеба
      ...studySectionAcademicYearsData.academicYears,
      // Наука
      ...scienceSectionAcademicYearsData.academicYears,
      // Спорт
      ...sportSectionAcademicYearsData.academicYears,
      // Творчество
      ...creationSectionAcademicYearsData.academicYears,
      // Культура
      ...cultureSectionAcademicYearsData.academicYears,
      // Гражданская активность
      ...civilSectionAcademicYearsData.academicYears,
      // Моя профессия
      ...professionSectionAcademicYearsData.academicYears,
    ]);

    return sortPeriods(periods);
  },
);
